import { createRoot } from 'react-dom/client';
import App from './app';
import { MultifactorSignInViewModel, SignInModel } from './components/UserModels';

const signInContainer = document.getElementById('sign-in-root');

//Default sign-in information (Method & email)
const signInModel = document.getElementById('signInModel') as HTMLInputElement;
const signInModelParsed = JSON.parse(signInModel ? signInModel.value : '{}') as SignInModel;

// MFA sign-in information based on claims
const multifactorSignInModel = document.getElementById('multifactorSignInViewModel') as HTMLInputElement;
const multifactorSignInModelParsed = JSON.parse(
  multifactorSignInModel ? multifactorSignInModel.value : '{}'
) as MultifactorSignInViewModel;

if (signInContainer) {
  const root = createRoot(signInContainer);
  root.render(<App signInModel={signInModelParsed} multifactorSignInModel={multifactorSignInModelParsed} />);
}
